import { FC, useState } from "react";
import { Button } from "../../../styles/button";
import CustomModal from "./CustomModal";

interface IProps {
  title: string;
  text: string;
  confirmText: string;
  isOpen: boolean;
  isFunction?: boolean;
  close(): void;
  confirm: () => Promise<void>;
}

const ModalSingleButton: FC<IProps> = ({
  title,
  text,
  confirmText,
  isOpen,
  isFunction,
  close,
  confirm,
}) => {
  const [saving, setSaving] = useState(false);

  const handleConfirm = async () => {
    if (isFunction) {
      await confirm();
      return;
    }

    setSaving(true);
    await confirm();
    setSaving(false);
    close();
  };

  return (
    <CustomModal
      title={title}
      isOpen={isOpen}
      close={close}
      actions={
        <>
          <Button disabled={saving} onClick={handleConfirm}>
            {confirmText}
          </Button>
        </>
      }
    >
      {text}
    </CustomModal>
  );
};

export default ModalSingleButton;
